import styled from "styled-components";
import Text from "../Text";
import { paletteHelper } from "../../utils";
import { pxToRem, transition } from "../../private/helpers";
var borderHelper = state => _ref => {
  var {
    theme,
    $errored
  } = _ref;
  var {
    border,
    palette
  } = theme;
  var borderBase = border.width.thin + " solid ";
  var colors = {
    disabled: palette.borderDisabled,
    checked: palette.borderSelected,
    checkedDisabled: palette.backgroundDisabled,
    focus: palette.borderFocused,
    pressed: palette.borderPressed,
    errored: palette.borderErrored,
    standard: palette.borderPrimary
  };
  if (state === "focus") return border.width.thick + " solid " + colors[state];else if ($errored) return border.width.thick + " solid " + colors.errored;else if (state) return borderBase + " " + colors[state];else return borderBase + " " + colors.standard;
};
var backgroundHelper = state => _ref2 => {
  var {
    theme
  } = _ref2;
  var {
    palette
  } = theme;
  var background = {
    hover: palette.backgroundHoveredPrimary,
    pressed: palette.backgroundPressedPrimary,
    checkedHover: palette.backgroundHoveredPrimaryInverted,
    checkedPressed: palette.backgroundPressedPrimaryInverted,
    standard: palette.backgroundPrimaryBase
  };
  return state ? background[state] : background.standard;
};
var sizeHelper = _ref3 => {
  var {
    theme,
    $sizeVariant
  } = _ref3;
  var {
    spacing
  } = theme;
  var size = {
    small: spacing.medium,
    large: spacing.large
  };
  return size[$sizeVariant];
};
var marginHelper = _ref4 => {
  var {
    theme,
    $sizeVariant,
    $noMargins
  } = _ref4;
  if ($noMargins) return "0";
  return $sizeVariant === "small" ? theme.spacing.twoExtraSmall : "0";
};
var VisibleLabel = styled(Text).attrs({
  variant: "body01"
}).withConfig({
  displayName: "styles__VisibleLabel",
  componentId: "sc-1b5tlm-0"
})(["display:block;cursor:pointer;"]);
var HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "styles__HiddenCheckbox",
  componentId: "sc-1b5tlm-1"
})(["width:", ";height:", ";position:absolute;margin:0;opacity:0;cursor:pointer;z-index:1;&:disabled{cursor:not-allowed;}"], sizeHelper, sizeHelper);
var StyledCheckbox = styled.div.withConfig({
  displayName: "styles__StyledCheckbox",
  componentId: "sc-1b5tlm-2"
})(["background-color:", ";border:", ";border-radius:", ";width:", ";height:", ";display:inline-block;position:absolute;transition:", ";", ":focus ~ &&::after{content:\"\";display:block;position:relative;width:calc(0.5rem + ", ");height:calc(0.5rem + ", ");border:", ";top:", ";left:", ";border-radius:", ";}", ":focus-visible ~ &&::after{content:\"\";display:block;position:relative;width:calc(0.5rem + ", ");height:calc(0.5rem + ", ");border:", ";top:", ";left:", ";border-radius:", ";}", ":focus:not(:focus-visible) ~ &&::after{border:none;}", ":checked ~ &&{background-color:", ";border:", ";}", ":disabled ~ &&{background-color:", ";border:", ";}", ":checked:disabled ~ &&{border:", ";}@media (hover:hover){", ":enabled:not(:checked):hover ~ &&{background-color:", ";}", ":enabled:checked:hover ~ &&{background-color:", ";}}", ":enabled:not(:checked):active ~ &&{background-color:", ";border:", ";}", ":enabled:checked:active ~ &&{background-color:", ";}"], backgroundHelper(), borderHelper(), _ref5 => {
  var {
    theme
  } = _ref5;
  return theme.border.radius.small;
}, sizeHelper, sizeHelper, transition(["background-color", "border"]), HiddenCheckbox, sizeHelper, sizeHelper, borderHelper("focus"), _ref6 => {
  var {
    $errored
  } = _ref6;
  return $errored ? pxToRem(-6) : pxToRem(-5);
}, _ref7 => {
  var {
    $errored
  } = _ref7;
  return $errored ? pxToRem(-6) : pxToRem(-5);
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.border.radius.small;
}, HiddenCheckbox, sizeHelper, sizeHelper, borderHelper("focus"), _ref9 => {
  var {
    $errored
  } = _ref9;
  return $errored ? pxToRem(-6) : pxToRem(-5);
}, _ref10 => {
  var {
    $errored
  } = _ref10;
  return $errored ? pxToRem(-6) : pxToRem(-5);
}, _ref11 => {
  var {
    theme
  } = _ref11;
  return theme.border.radius.small;
}, HiddenCheckbox, HiddenCheckbox, _ref12 => {
  var {
    theme,
    $errored
  } = _ref12;
  return $errored ? theme.palette.borderErrored : theme.palette.backgroundSelected;
}, borderHelper("checked"), HiddenCheckbox, paletteHelper("backgroundDisabled"), borderHelper("disabled"), HiddenCheckbox, borderHelper("checkedDisabled"), HiddenCheckbox, backgroundHelper("hover"), HiddenCheckbox, backgroundHelper("checkedHover"), HiddenCheckbox, backgroundHelper("pressed"), borderHelper("pressed"), HiddenCheckbox, backgroundHelper("checkedPressed"));
var CheckMarkSvg = styled.svg.withConfig({
  displayName: "styles__CheckMarkSvg",
  componentId: "sc-1b5tlm-3"
})(["width:", ";height:", ";position:absolute;display:none;cursor:pointer;color:", ";", ":checked ~ &&{display:block;}", ":disabled ~ &&{cursor:not-allowed;color:", ";}"], sizeHelper, sizeHelper, paletteHelper("textInverted"), HiddenCheckbox, HiddenCheckbox, paletteHelper("textDisabled"));
var colorHelper = _ref13 => {
  var {
    $disabled,
    $errored,
    theme
  } = _ref13;
  var {
    palette
  } = theme;
  var colors = {
    disabled: palette.textDisabled,
    errored: palette.textWarning
  };
  if ($disabled) return colors.disabled;else if ($errored) return colors.errored;else return "inherit";
};
var Wrapper = styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1b5tlm-4"
})(["display:flex;text-align:left;align-items:flex-start;color:", ";position:relative;"], colorHelper);
var CheckboxContainer = styled.div.withConfig({
  displayName: "styles__CheckboxContainer",
  componentId: "sc-1b5tlm-5"
})(["position:relative;width:", ";height:", ";margin-top:", ";margin-right:", ";flex-shrink:0;"], sizeHelper, sizeHelper, marginHelper, _ref14 => {
  var {
    theme,
    $noMargins
  } = _ref14;
  return $noMargins ? "0" : theme.spacing.small;
});
export { VisibleLabel, HiddenCheckbox, StyledCheckbox, CheckMarkSvg, Wrapper, CheckboxContainer };